import { useEffect, useState, useRef } from 'react';
import { createFileRoute, useSearch } from '@tanstack/react-router';
import { type SessionKeySearchParams, restoreAppState } from '@/util/app-state';
import { removeSearchParamsFromUrl } from '@/util/http-utils';
import Loading from '@/components/Loading';
import Profile from '@/components/Profile';
import styles from './profile.module.css';

const route = '/profile/';

export const Route = createFileRoute(route)({
  component: ProfilePage,
})

interface ProfileSearchParams extends SessionKeySearchParams {
    next?: string;
    show_subscribe?: boolean;
}

function ProfilePage() {
  const initialized = useRef(false);
  const { key, next, show_subscribe } = useSearch({ from: route }) as ProfileSearchParams;
  const [showSubscribeButton, setShowSubscribeButton] = useState(false);
  const [nextPath, setNextPath] = useState("/");
  
  useEffect(() => {
    if (!initialized.current) {
      setShowSubscribeButton(true);
      if (key) {
        restoreAppState(key);
      }
      if (next) {
        const tempPath = next;
        setNextPath(tempPath);
      }
      if (show_subscribe != null) {
        setShowSubscribeButton(show_subscribe);
      }
      removeSearchParamsFromUrl();
      initialized.current = true;
    }
  }, []);

  if (initialized.current === false) {
    return <Loading />
  }

  return (
    <div className={styles.pageContainer}>
        <Profile showSubscribe={showSubscribeButton} next={nextPath} />
    </div>
  );
}
